var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/constant/website.js
var require_website = __commonJS({
  "src/constant/website.js"(exports, module) {
    module.exports = {
      IELTS_LIBRARY: {
        url: "/ielts-library",
        BLOGS: {
          url: "/ielts-library/blogs"
        }
      },
      IELTS: {
        url: "ielts"
      }
    };
  }
});

// src/style/colors-v2.js
var colorsV2 = {
  accent01_100: "#EF692F",
  grey30: "#DFE1E6",
  grey70: "#5E6C84",
  grey100: "#242C34",
  black100: "#242938",
  black80: "#505460",
  black60: "#7C7F88",
  black40: "#A7A9AF",
  black20: "#D3D4D7",
  black10: "#E9EAEB",
  black5: "#F4F4F5",
  blackShadow1: "rgba(0, 0, 0, 0.01)",
  blackShadow2: "rgba(0, 0, 0, 0.02)",
  blackShadow3: "rgba(0, 0, 0, 0.03)",
  blackShadow4: "rgba(0, 0, 0, 0.04)",
  blackShadow5: "rgba(0, 0, 0, 0.05)",
  blackShadow6: "rgba(0, 0, 0, 0.06)",
  blackShadow7: "rgba(0, 0, 0, 0.07)",
  white100: "#FFFFFF",
  white80: "rgba(255, 255, 255, 0.8)",
  white60: "rgba(255, 255, 255, 0.6)",
  white40: "rgba(255, 255, 255, 0.4)",
  white20: "rgba(255, 255, 255, 0.2)",
  white10: "rgba(255, 255, 255, 0.1)",
  white5: "rgba(255, 255, 255, 0.05)",
  gray120: "#6D7D8D",
  gray100: "#8F92A1",
  gray80: "#A5A8B4",
  gray60: "#BCBEC7",
  gray50: "#D5D7E1",
  gray40: "#D2D3D9",
  gray20: "#E9E9EC",
  gray10: "#F4F4F6",
  gray5: "#F9FAFA",
  lightGray100: "#F3F6F8",
  lightGray80: "#F5F8F9",
  lightGray60: "#F8FAFB",
  lightGray40: "#FAFBFC",
  lightGray20: "#FDFDFE",
  lightGray10: "#FEFEFE",
  lightGray5: "#FEFFFF",
  primary100: "#D14242",
  primary80: "#DA6868",
  primary60: "#E38E8E",
  primary40: "#EDB3B3",
  primary20: "#F6D9D9",
  primary10: "#FAECEC",
  primary5: "#FDF6F6",
  pink100: "#F8B6C3",
  pink80: "#F9C5CF",
  pink60: "#FBD3DB",
  pink40: "#FCE2E7",
  pink20: "#FEF0F3",
  pink10: "#FEF8F9",
  pink5: "#FFFBFC",
  yellow120: "#dd7800",
  yellow100: "#FF991F",
  yellow80: "#FFAD4C",
  yellow60: "#FFC279",
  yellow40: "#FFD6A5",
  yellow20: "#FFEBD2",
  yellow10: "#FFF5E9",
  yellow5: "#FFFAF4",
  purple100: "#5243AA",
  purple80: "#7569BB",
  purple60: "#978ECC",
  purple40: "#BAB4DD",
  purple20: "#D5CBF6",
  purple10: "#F1EDFC",
  purple5: "#F6F6FB",
  green120: "#329546",
  green100: "#358756",
  green80: "#5D9F78",
  green60: "#86B79A",
  green40: "#AECFBB",
  green20: "#D7E7DD",
  green10: "#EBF3EE",
  green5: "#F5F9F7",
  red100: "#DE350B",
  red80: "#E55D3C",
  red60: "#EB866D",
  red40: "#F2AE9D",
  red20: "#F8D7CE",
  red10: "#FCEBE7",
  red5: "#FDF5F3",
  blue180: "#0F2657",
  blue160: "#143171",
  blue140: "#1B4193",
  blue120: "#2250B4",
  blue100: "#2B61D4",
  blue80: "#5480DE",
  blue60: "#7D9FE8",
  blue40: "#A7BFF1",
  blue20: "#CAD8F7",
  blue10: "#EDF2FD",
  blue5: "#F6F8FE",
  neutral200: "#21262D",
  neutral180: "#313A44",
  neutral160: "#434E5B",
  neutral140: "#5A6877",
  neutral120: "#6D7D8D",
  neutral100: "#8594A3",
  neutral80: "#A1ADB9",
  neutral70: "#5E6C84",
  neutral60: "#B8C1CC",
  neutral50: "#D5D7E1",
  neutral40: "#D2D8DF",
  neutral20: "#E3E7ED",
  neutral10: "#F2F4F7",
  neutral5: "#F9FAFB",
  blackTransparent100: "#000000",
  blackTransparent90: "rgba(0, 0, 0, 0.90)",
  blackTransparent80: "rgba(0, 0, 0, 0.80)",
  blackTransparent70: "rgba(0, 0, 0, 0.70)",
  blackTransparent60: "rgba(0, 0, 0, 0.60)",
  blackTransparent50: "rgba(0, 0, 0, 0.50)",
  blackTransparent40: "rgba(0, 0, 0, 0.40)",
  blackTransparent30: "rgba(0, 0, 0, 0.30)",
  blackTransparent20: "rgba(0, 0, 0, 0.20)",
  blackTransparent10: "rgba(0, 0, 0, 0.10)",
  blackTransparent5: "rgba(0, 0, 0, 0.05)",
  paper: "#FFF9F1",
  paper10: "#FFF6EB",
  paper40: "#FCE1BF",
  paper60: "#F7CC9C",
  paper120: "#CC7926",
  paper160: "#965B19",
  paper180: "#8F5717",
  neutralPrimary: "#313A44",
  DS100: "#27A3CD",
  DS10: "#DCF5FE",
  CA100: "#E25328"
};

// src/shared-external/CommonFooter.js
import styled9 from "styled-components";
import React12 from "react";

// src/utils/media-query/media-query.js
var fromWidth = (minWidth) => `(min-width: ${minWidth}px)`;

// src/utils/media-query/responsive.util.js
import * as React from "react";
var fromScreen = (minWidth) => `@media screen and ${fromWidth(minWidth)}`;

// src/apis/baseURL.js
var LMS = `${process.env.GATSBY_LMS_API_URL}/api`;
var HUBSPOT = {
  API_KEY: process.env.HUBSPOT_API_KEY,
  PORTAL_ID: process.env.HUBSPOT_PORTAL_ID,
  FORM_ID: process.env.HUBSPOT_FORM_ID
};
var GATSBY_ACTIVE_ENV = `${process.env.GATSBY_ACTIVE_ENV}`;
var GATSBY_BUILD_DATE = `${process.env.GATSBY_BUILD_DATE}`;
var GATSBY_GRAPH_CMS_URI = `${process.env.GATSBY_GRAPH_CMS_URI}`;
var GATSBY_GRAPH_CMS_AUTHORIZATION = `${process.env.GATSBY_GRAPH_CMS_AUTHORIZATION}`;
var SITE_URL = `${process.env.SITE_URL}`;
var TEXT_TO_SPEECH_URL = `${process.env.TEXT_TO_SPEECH_URL}`;
var APPLY_JOB_URL = `${process.env.APPLY_JOB_URL}`;
var STUDENT_REGISTRATION_URL = `${process.env.STUDENT_REGISTRATION_URL}`;
var GATSBY_GIT_SHA = `${process.env.GATSBY_GIT_SHA}`;
var GO_USER_SERVICE = `${process.env.GO_USER_SERVICE}`;

// src/content/langs.json
var langs_default = [
  {
    id: 2,
    value: "vi",
    name: "Ti\u1EBFng Vi\u1EC7t"
  }
];

// src/constant/courses.js
var courseDetailPropertyKey = {
  METHODOLOGIES: "methodologies",
  SYLLABUS: "syllabus",
  TEACHERS: "teachers",
  SCHEDULES: "schedules"
};
var courseDetailPropertyKeys = [
  courseDetailPropertyKey.METHODOLOGIES,
  courseDetailPropertyKey.SYLLABUS,
  courseDetailPropertyKey.TEACHERS,
  courseDetailPropertyKey.SCHEDULES
];

// src/constant/index.js
var import_website = __toESM(require_website());
var GRAPH_CMS_CDN = "https://asset.dolenglish.vn";
var constant_default = {
  DEFAULT_LANG: langs_default[0],
  FACEBOOK_APP_ID: "722752771433071",
  DOL_ENGLISH: {
    HOMEPAGE: SITE_URL,
    IELTS_REVIEW_RESULT: "/hall-of-fame",
    FACEBOOK_PAGE_ID: "391463584761881"
  },
  DOL_ONLINE: {
    HOMEPAGE: "https://www.dolonline.com"
  },
  LOGO_WIDTH: 120,
  DESKTOP_MAX_WIDTH: 1440,
  DESKTOP_MENU_MAX_WIDTH: 1440,
  DESKTOP_HEADER_HEIGHT: 50,
  DESKTOP_HEADER_LOGO_MARGIN: 0,
  DESKTOP13INCHE_HEADER_LOGO_MARGIN: 50,
  DESKTOP_PRICING_WIDTH: 250,
  DESKTOP_STICKY_NAV_HEIGHT: 70,
  DESKTOP_STICKY_MAX_WIDTH: 850,
  MOBILE_HEADER_HEIGHT: 54,
  BREAKPOINT_MOBILE_STICKY_NAV_FULL_WIDTH: 600,
  BREAKPOINT_BURGER_MENU: 1280,
  GRAPH_CMS_CDN: "https://asset.dolenglish.vn",
  REVIEWS_PER_PAGE: 10
};

// src/utils/getAssetLink.js
var getAssetLink = ({ item, width, height }) => {
  if (!item)
    return null;
  if (!width && !height) {
    return `${GRAPH_CMS_CDN}/${item.handle}`;
  }
  if (width && !height) {
    return `${GRAPH_CMS_CDN}/resize=w:${width},fit:crop/${item.handle}`;
  }
  if (!width && height) {
    return `${GRAPH_CMS_CDN}/resize=h:${height},fit:crop/${item.handle}`;
  }
  return `${GRAPH_CMS_CDN}/resize=w:${width},h:${height},fit:crop/${item.handle}`;
};
var getAssetLinkByHandle = ({ handle, width, height }) => {
  return getAssetLink({ item: { handle }, width, height });
};

// node_modules/@dolstaff/shared/es/icons/OutlineArrowChevronDown.js
import React3 from "react";

// node_modules/@dolstaff/shared/es/Icon/index.js
import React2 from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var getSize = (number) => `${number}px`;
var getStrokeWidth = (size) => {
  if (size >= 32) {
    return 2;
  }
  if (size >= 24) {
    return 1.5;
  }
  return 1.5;
};
var StyledSvg = (_ref) => {
  let {
    className,
    color,
    viewBox,
    dataTest,
    children,
    ariaHidden,
    ariaLabel
  } = _ref, props = _objectWithoutProperties(_ref, ["className", "color", "viewBox", "dataTest", "children", "ariaHidden", "ariaLabel"]);
  return React2.createElement("svg", _extends({}, props, {
    className,
    viewBox,
    "data-test": dataTest,
    preserveAspectRatio: "xMidYMid meet",
    "aria-hidden": ariaHidden ? "true" : void 0,
    "aria-label": ariaLabel,
    color
  }), children);
};
var StyledIcon = styled(StyledSvg).withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "sc-17nvvtn-0"
})(["width:", ";height:", ";flex-shrink:0;vertical-align:middle;fill:transparent;path{stroke-width:", "px;}"], ({
  width
}) => getSize(width), ({
  height
}) => getSize(height), ({
  size
}) => getStrokeWidth(size));
var Icon = (props) => {
  const {
    size = 24,
    width,
    height,
    color,
    customColor,
    className,
    children,
    viewBox,
    dataTest,
    ariaHidden,
    reverseOnRtl,
    ariaLabel
  } = props;
  return React2.createElement(StyledIcon, {
    viewBox,
    size,
    width,
    height: height || size,
    color,
    className,
    dataTest,
    customColor,
    ariaHidden,
    reverseOnRtl,
    ariaLabel
  }, children);
};
Icon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  customColor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  viewBox: PropTypes.string,
  dataTest: PropTypes.string,
  ariaHidden: PropTypes.string,
  reverseOnRtl: PropTypes.string,
  ariaLabel: PropTypes.string
};
var Icon_default = Icon;

// node_modules/@dolstaff/shared/es/icons/OutlineArrowChevronDown.js
var OutlineArrowChevronDown = (props) => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React3.createElement(Icon_default, {
    viewBox: "0 0 24 24",
    size,
    width,
    height,
    color,
    customColor,
    className,
    dataTest,
    ariaHidden,
    reverseOnRtl,
    ariaLabel
  }, React3.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 13.586l4.293-4.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L12 13.586z",
    clipRule: "evenodd"
  }));
};
var OutlineArrowChevronDown_default = OutlineArrowChevronDown;

// src/shared-external/BranchExpandCollapse.js
import cl2 from "classnames";

// src/components/DesignSystemV2/ResponsiveTypography.js
import cl from "classnames";
import * as React4 from "react";
import styled2, { css } from "styled-components";

// src/components/DesignSystemV2/ResponsiveSystem.js
import { isNil } from "lodash";
var validBreakPointProps = [
  "color",
  "m",
  "mt",
  "marginTop",
  "mr",
  "marginRight",
  "mb",
  "marginBottom",
  "ml",
  "marginLeft",
  "mx",
  "marginX",
  "my",
  "marginY",
  "p",
  "pt",
  "paddingTop",
  "pr",
  "paddingRight",
  "pb",
  "paddingBottom",
  "pl",
  "paddingLeft",
  "px",
  "paddingX",
  "py",
  "paddingY"
];
var resolveSystemColor = (colorName) => {
  return colorsV2[colorName] || colorName;
};
var resolveNumberOrPx = (value) => {
  if (typeof value === "string") {
    return value;
  }
  return `${value}px`;
};
var resolveAttr = (attrName, attrValue) => {
  switch (attrName) {
    case "$color": {
      return `color: ${resolveSystemColor(attrValue)};`;
    }
    case "$m":
      return `margin: ${resolveNumberOrPx(attrValue)};`;
    case "$mt":
    case "$marginTop":
      return `margin-top: ${resolveNumberOrPx(attrValue)};`;
    case "$mr":
    case "$marginRight":
      return `margin-right: ${resolveNumberOrPx(attrValue)};`;
    case "$mb":
    case "$marginBottom":
      return `margin-bottom: ${resolveNumberOrPx(attrValue)};`;
    case "$ml":
    case "$marginLeft":
      return `margin-left: ${resolveNumberOrPx(attrValue)};`;
    case "$mx":
    case "$marginX":
      return `margin-left: ${resolveNumberOrPx(attrValue)};
      margin-right: ${resolveNumberOrPx(attrValue)};`;
    case "$my":
    case "$marginY":
      return `margin-top: ${resolveNumberOrPx(attrValue)};
      margin-bottom: ${resolveNumberOrPx(attrValue)};`;
    case "$p":
      return `padding: ${resolveNumberOrPx(attrValue)};`;
    case "$pt":
    case "$paddingTop":
      return `padding-top: ${resolveNumberOrPx(attrValue)};`;
    case "$pr":
    case "$paddingRight":
      return `padding-right: ${resolveNumberOrPx(attrValue)};`;
    case "$pb":
    case "$paddingBottom":
      return `padding-bottom: ${resolveNumberOrPx(attrValue)};`;
    case "$pl":
    case "$paddingLeft":
      return `padding-left: ${resolveNumberOrPx(attrValue)};`;
    case "$px":
    case "$paddingX":
      return `padding-left: ${resolveNumberOrPx(attrValue)};
      padding-right: ${resolveNumberOrPx(attrValue)};`;
    case "$py":
    case "$paddingY":
      return `padding-top: ${resolveNumberOrPx(attrValue)};
      padding-bottom: ${resolveNumberOrPx(attrValue)};`;
    default:
  }
  return `${attrName}: ${resolveNumberOrPx(attrValue)};`;
};
var toTransientProps = (propName, extraBreakPointProps = []) => [...validBreakPointProps, ...extraBreakPointProps].includes(propName) ? `$${propName}` : propName;
var responsiveBreakPointPropsToTrasientProps = (props, extraBreakPointProps = []) => {
  const result = {};
  Object.keys(props).forEach((propName) => {
    result[toTransientProps(propName, extraBreakPointProps)] = props[propName];
  });
  return result;
};
var memGeneratedStyled = {};
var genStyledCode = ({
  breakpoints,
  customResolveAttrs,
  p,
  filteredProps
}) => {
  if (breakpoints) {
    const breakPointsHashMap = {};
    breakpoints.forEach((breakPoint, breakPointIndex) => {
      const styleCodeArr = filteredProps.map((attrName) => {
        let attrValue = p[attrName];
        if (p[attrName] instanceof Array) {
          attrValue = isNil(p[attrName][breakPointIndex]) ? p[attrName][0] : p[attrName][breakPointIndex];
        }
        if (validBreakPointProps.map((propName) => toTransientProps(propName)).includes(attrName)) {
          return resolveAttr(attrName, attrValue);
        }
        return customResolveAttrs(attrName, attrValue);
      });
      breakPointsHashMap[breakPoint] = styleCodeArr.join(" ");
    });
    const keys = Object.keys(breakPointsHashMap);
    if (breakPointsHashMap[keys[0]] === breakPointsHashMap[keys[1]] && breakPointsHashMap[keys[1]] === breakPointsHashMap[keys[2]]) {
      return `${breakPointsHashMap[keys[0]]}`;
    }
    if (breakPointsHashMap[keys[1]] === breakPointsHashMap[keys[2]]) {
      return `
      ${breakPointsHashMap[keys[0]]}
      ${fromScreen(Number(keys[1]))} {
        ${breakPointsHashMap[keys[1]]}
      }`;
    }
    return Object.keys(breakPointsHashMap).map((fromScreenWidth) => {
      if (Number(fromScreenWidth) === 0) {
        return `${breakPointsHashMap[fromScreenWidth]}`;
      }
      return `${fromScreen(Number(fromScreenWidth))} {
          ${breakPointsHashMap[fromScreenWidth]}
        }`;
    }).join(" ");
  }
  return filteredProps.map((attrName) => {
    if (p[attrName] instanceof Array) {
      return resolveAttr(attrName, p[attrName]);
    }
    return resolveAttr(attrName, p[attrName]);
  }).join(" ");
};
var composeBreakPointStyle = (p, blackListProps = [], customResolveAttrs = resolveAttr) => {
  const breakpoints = p.breakpoints || [0, 768, 1280];
  const filteredProps = Object.keys(p).filter(
    (attrName) => attrName && ![
      "breakpoints",
      "theme",
      "children",
      "className",
      "data-testid",
      "style",
      ...blackListProps
    ].includes(attrName) && attrName.startsWith("$")
  );
  const hash = `${filteredProps.map((item) => `${item}_${p[item]}`).join("-")}||${breakpoints.join("_")}`;
  if (memGeneratedStyled[hash]) {
    return memGeneratedStyled[hash];
  }
  const genCode = genStyledCode({
    breakpoints,
    customResolveAttrs,
    p,
    filteredProps
  });
  memGeneratedStyled[hash] = genCode;
  return genCode;
};
var numberToPxCss = (input) => {
  const whitelist = ["inherit", "auto", "initial"];
  if (whitelist.includes(input)) {
    return input;
  }
  if (!input.includes("px") && !input.includes("em")) {
    return `${input}px`.trim();
  }
  return `${input}`.trim();
};

// src/components/DesignSystemV2/ResponsiveTypography.js
var VARIANT_FONT_WEIGHT_MAPPING = {
  regular: 400,
  medium: 500,
  "semi-bold": 600,
  semibold: 600,
  bold: 700,
  black: 900
};
var customResolveAttr = (attrName, attrValue) => {
  if (attrName === "$variant") {
    let lineHeight = "1.5em";
    const isValidVariant = Object.keys(VARIANT_FONT_WEIGHT_MAPPING).some(
      (fontWeightName) => {
        if (attrValue) {
          return attrValue.toLowerCase().includes(fontWeightName);
        }
        return false;
      }
    );
    if (!isValidVariant)
      throw new Error(
        `Variant name "${attrName}" with value "${attrValue}" not valid, for example: Bold/16px | 24px`
      );
    const [variantName, fontProperties] = attrValue.split("/");
    const [fontSize, lineHeightExtracted] = fontProperties.split(/\||-/g);
    if (lineHeightExtracted) {
      lineHeight = lineHeightExtracted;
    }
    return `font-weight: ${VARIANT_FONT_WEIGHT_MAPPING[variantName.trim().toLowerCase()]};
      line-height: ${numberToPxCss(lineHeight)};
      font-size: ${numberToPxCss(fontSize)};
    `;
  }
  return `${attrName}: ${attrValue};`;
};
var shareStyle = css`
  color: inherit;
  &.responsive-typography.dol.dol-typo {
    margin: 0;
    ${(p) => composeBreakPointStyle(p, ["ellipsis"], customResolveAttr)}
  }
`;
var EnhancedAntdText = styled2.span.withConfig({
  componentId: "ResponsiveTypography_EnhancedAntdText"
})`
  ${shareStyle};
`;
var Text = (props) => {
  const { className, ...innerProps } = props;
  const { children, style, ellipsis, ...rest } = innerProps;
  return /* @__PURE__ */ React4.createElement(EnhancedAntdText, {
    className: cl("responsive-typography", "dol", "dol-typo", className),
    style,
    ellipsis,
    ...responsiveBreakPointPropsToTrasientProps(rest, ["variant"])
  }, children);
};
var EnhancedAntdParagraph = styled2.p.withConfig({
  componentId: "ResponsiveTypography_EnhancedAntdParagraph"
})`
  ${shareStyle};
`;
var Paragraph = (props) => {
  const { className, ...innerProps } = props;
  const { style, ellipsis, ...rest } = innerProps;
  return /* @__PURE__ */ React4.createElement(EnhancedAntdParagraph, {
    ...rest,
    className: cl("responsive-typography", "dol", "dol-typo", className),
    style,
    ellipsis,
    ...responsiveBreakPointPropsToTrasientProps(rest, ["variant"])
  });
};
var ResponsiveTypography = {
  Text: React4.memo(Text),
  Paragraph: React4.memo(Paragraph)
};

// src/components/Divider/LineDivider/DividerLineDivider.js
import * as React5 from "react";
import styled3 from "styled-components";
import PropTypes2 from "prop-types";
var VerticalLine = styled3.div`
  width: ${(p) => p.size}px;
  height: 100%;
  margin: 0 ${(p) => p.space}px;
  background-color: ${(p) => p.color};
`;
var HorizontalLine = styled3.div`
  width: 100%;
  height: ${(p) => p.size}px;
  margin: ${(p) => p.space}px 0;
  background-color: ${(p) => p.color};
`;
var DividerLineDivider = (props) => {
  const {
    direction = "horizontal",
    size = 1,
    space = 0,
    color = colorsV2.gray20
  } = props;
  if (direction === "vertical") {
    return /* @__PURE__ */ React5.createElement(VerticalLine, {
      size,
      space,
      color
    });
  }
  return /* @__PURE__ */ React5.createElement(HorizontalLine, {
    size,
    space,
    color
  });
};
DividerLineDivider.propTypes = {
  direction: PropTypes2.oneOf(["horizontal", "vertical"]),
  size: PropTypes2.number,
  space: PropTypes2.number,
  color: PropTypes2.string
};

// src/shared-external/BranchExpandCollapse.js
import * as React6 from "react";
import styled4 from "styled-components";
var Main = styled4.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 12px;

  a {
    color: inherit;
    &:hover {
      color: ${colorsV2.primary100};
    }
  }
`;
var TextLinkWrapper = styled4.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  &.expanded {
    svg {
      transform: rotate(180deg);
    }
  }
`;
var TextLink = ({ onClick, expanded }) => {
  return /* @__PURE__ */ React6.createElement(TextLinkWrapper, {
    className: cl2("text-link", { expanded }),
    onClick
  }, /* @__PURE__ */ React6.createElement(ResponsiveTypography.Paragraph, {
    variant: "semi-bold/14-20",
    color: "gray120"
  }, expanded ? "Thu g\u1ECDn" : "Xem th\xEAm"), /* @__PURE__ */ React6.createElement(OutlineArrowChevronDown_default, {
    color: colorsV2.gray120
  }));
};
var BranchExpandCollapse = ({ title, list }) => {
  const [expanded, setExpanded] = React6.useState(false);
  const data = React6.useMemo(() => {
    if (!expanded) {
      return list?.length > 3 ? list.slice(0, 3) : list;
    }
    return list;
  }, [expanded, list]);
  return /* @__PURE__ */ React6.createElement(Main, null, /* @__PURE__ */ React6.createElement(ResponsiveTypography.Paragraph, {
    variant: "bold/14-20",
    color: "gray100"
  }, title), /* @__PURE__ */ React6.createElement(DividerLineDivider, {
    direction: "horizontal",
    size: 1,
    color: colorsV2.black80
  }), (data || []).map((item, idx) => /* @__PURE__ */ React6.createElement(ResponsiveTypography.Paragraph, {
    variant: "regular/14-20",
    color: "white100",
    key: idx
  }, /* @__PURE__ */ React6.createElement("b", null, "C\u01A1 s\u1EDF ", item?.centerNumber, ": "), /* @__PURE__ */ React6.createElement("a", {
    href: item.mapLink,
    target: "_blank",
    key: idx,
    rel: "noreferrer"
  }, item.address))), list?.length > 3 && /* @__PURE__ */ React6.createElement(TextLink, {
    onClick: () => setExpanded((o) => !o),
    expanded
  }));
};

// src/shared-external/ColumnContact.js
import * as React7 from "react";
import styled5 from "styled-components";
var Main2 = styled5.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 12px;

  a {
    color: inherit;
    &:hover {
      color: ${colorsV2.primary100};
    }
  }
`;
var ColumnContact = ({ title, list }) => {
  return /* @__PURE__ */ React7.createElement(Main2, null, /* @__PURE__ */ React7.createElement(ResponsiveTypography.Paragraph, {
    variant: "bold/14-20",
    color: "gray100"
  }, title), /* @__PURE__ */ React7.createElement(DividerLineDivider, {
    direction: "horizontal",
    size: 1,
    color: colorsV2.black80
  }), (list || []).map((item, idx) => {
    if (item.description) {
      return /* @__PURE__ */ React7.createElement(ResponsiveTypography.Paragraph, {
        variant: "regular/14-20",
        color: "white100",
        key: idx
      }, /* @__PURE__ */ React7.createElement("b", null, item.title, ": "), /* @__PURE__ */ React7.createElement("a", {
        href: item.link,
        target: item.openNewTab ? "_blank" : "_self",
        key: idx,
        rel: "noreferrer"
      }, item.description));
    }
    return /* @__PURE__ */ React7.createElement(ResponsiveTypography.Paragraph, {
      variant: "bold/14-20",
      color: "white100",
      key: idx
    }, /* @__PURE__ */ React7.createElement("a", {
      href: item.link,
      target: item.openNewTab ? "_blank" : "_self",
      key: idx,
      rel: "noreferrer"
    }, item.title));
  }));
};

// src/shared-external/ColumnInfo.js
import * as React8 from "react";
import styled6 from "styled-components";
var Main3 = styled6.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 12px;

  a {
    color: inherit;
    &:hover {
      color: ${colorsV2.primary100};
    }
  }
`;
var ColumnInfo = ({ title, list }) => {
  return /* @__PURE__ */ React8.createElement(Main3, null, /* @__PURE__ */ React8.createElement(ResponsiveTypography.Paragraph, {
    variant: "bold/14-20",
    color: "gray100"
  }, title), /* @__PURE__ */ React8.createElement(DividerLineDivider, {
    direction: "horizontal",
    size: 1,
    color: colorsV2.black80
  }), list?.map((item, idx) => /* @__PURE__ */ React8.createElement(ResponsiveTypography.Paragraph, {
    variant: "medium/14-20",
    color: "white100",
    key: idx
  }, /* @__PURE__ */ React8.createElement("a", {
    href: item?.link,
    target: item?.openNewTab ? "_blank" : "_self",
    rel: "noreferrer"
  }, item?.name))));
};

// src/shared-external/DmcaFooter.js
import styled7 from "styled-components";
import * as React10 from "react";

// src/shared-external/DCMA.js
import * as React9 from "react";
var DCMA = ({ shouldRender = false }) => {
  if (shouldRender)
    return /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement("a", {
      href: "//www.dmca.com/Protection/Status.aspx?ID=36c8b284-aa13-4f7c-96a6-e7e419ec8411",
      title: "DMCA.com Protection Status",
      className: "dmca-badge"
    }, /* @__PURE__ */ React9.createElement("img", {
      width: 102,
      height: 24,
      src: "https://images.dmca.com/Badges/dmca_protected_sml_120i.png?ID=36c8b284-aa13-4f7c-96a6-e7e419ec8411",
      alt: "DMCA.com Protection Status"
    })), /* @__PURE__ */ React9.createElement("script", {
      src: "https://images.dmca.com/Badges/DMCABadgeHelper.min.js"
    }));
  return null;
};

// src/shared-external/DmcaFooter.js
var Main4 = styled7.div`
  padding: 32px 0;
  border-top: 1px solid ${colorsV2.black80};

  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  align-items: start;
  gap: 12px;

  .list {
    display: flex;
    > * {
      &:not(:last-child) {
        padding-right: 8px;
        border-right: 1px solid ${colorsV2.gray100};
      }
      &:not(:first-child) {
        padding-left: 8px;
      }
    }
    a {
      color: inherit;
      &:hover {
        color: ${colorsV2.primary100};
      }
    }
  }

  ${fromScreen(776)} {
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    justify-content: space-between;
  }
`;
var DmcaFooter = ({ list, shouldRenderDMCA }) => {
  return /* @__PURE__ */ React10.createElement(Main4, null, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(ResponsiveTypography.Paragraph, {
    variant: "regular/14-20",
    color: "gray10",
    mb: "8px"
  }, "\xA9 ", new Date().getFullYear(), " DOL English. All rights reserved."), /* @__PURE__ */ React10.createElement(ResponsiveTypography.Paragraph, {
    variant: "regular/14-20",
    color: "gray10",
    mb: "8px"
  }, "Thu\u1ED9c s\u1EDF h\u1EEFu c\u1EE7a C\xF4ng ty TNHH DOL English ", /* @__PURE__ */ React10.createElement("br", null), "MST: 0315174306"), /* @__PURE__ */ React10.createElement(DCMA, {
    shouldRender: shouldRenderDMCA
  })), /* @__PURE__ */ React10.createElement("div", {
    className: "list"
  }, list?.map((item, idx) => /* @__PURE__ */ React10.createElement("a", {
    href: item.link,
    key: idx
  }, /* @__PURE__ */ React10.createElement(ResponsiveTypography.Paragraph, {
    variant: "regular/14-20",
    color: "gray100"
  }, item?.name)))));
};

// src/shared-external/FollowDol.js
import styled8 from "styled-components";
import * as React11 from "react";
var SocialIcon = styled8.img`
  width: 40px;
  height: 40px;
`;
var Main5 = styled8.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 8px;

  .list {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 16px;
  }
`;
var Social = ({ link, icon, alt }) => /* @__PURE__ */ React11.createElement("a", {
  "aria-label": alt || icon || "social",
  href: link,
  rel: "nofollow noreferrer",
  target: "_blank"
}, /* @__PURE__ */ React11.createElement(SocialIcon, {
  src: getAssetLinkByHandle({ handle: icon }),
  alt: alt || icon
}));
var FollowDol = ({ list }) => {
  return /* @__PURE__ */ React11.createElement(Main5, null, /* @__PURE__ */ React11.createElement(ResponsiveTypography.Paragraph, {
    variant: "bold/14-20",
    color: "white100"
  }, "Theo d\xF5i DOL t\u1EA1i"), /* @__PURE__ */ React11.createElement("div", {
    className: "list"
  }, (list || []).map((item, itemIndex) => {
    return /* @__PURE__ */ React11.createElement(Social, {
      key: itemIndex,
      ...item
    });
  })));
};

// src/shared-external/CommonFooter.js
var Container = styled9.div`
  max-width: 1080px;
  margin: 0 auto;
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 40px;
`;
var Main6 = styled9.footer`
  padding: 32px 16px;
  background-color: ${colorsV2.black100};
  ${fromScreen(458)} {
    padding: 32px;
  }
`;
var Content = styled9.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 32px;
`;
var CenterList = styled9.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 36px;
`;
var CourseLayout = styled9.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 32px;

  .right-area {
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    gap: 24px;
  }

  ${fromScreen(776)} {
    gap: 60px;
  }
`;
var Layout = styled9.div`
  display: grid;
  gap: 24px;

  ${fromScreen(776)} {
    gap: 60px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
var CommonFooter = ({ data = {}, shouldRenderDMCA = false }) => {
  return /* @__PURE__ */ React12.createElement(Main6, {
    className: "common-footer",
    id: "footer"
  }, /* @__PURE__ */ React12.createElement(Container, null, /* @__PURE__ */ React12.createElement(Content, null, /* @__PURE__ */ React12.createElement("img", {
    src: getAssetLinkByHandle({ handle: "sFYcPsHEQbKIZMTiAGtL" }),
    alt: "Logo DOL English"
  }), /* @__PURE__ */ React12.createElement(Layout, null, /* @__PURE__ */ React12.createElement(CenterList, null, /* @__PURE__ */ React12.createElement(BranchExpandCollapse, {
    title: `C\u01A0 S\u1EDE T\u1EA0I TPHCM (${data.centerHcm?.length})`,
    list: data.centerHcm
  }), /* @__PURE__ */ React12.createElement(BranchExpandCollapse, {
    title: `C\u01A0 S\u1EDE T\u1EA0I H\xC0 N\u1ED8I (${data.centerHN?.length})`,
    list: data.centerHN
  }), /* @__PURE__ */ React12.createElement(BranchExpandCollapse, {
    title: `C\u01A0 S\u1EDE T\u1EA0I \u0110\xC0 N\u1EB4NG (${data.centerDN?.length})`,
    list: data.centerDN
  }), /* @__PURE__ */ React12.createElement(ColumnContact, {
    title: "TH\xD4NG TIN LI\xCAN H\u1EC6",
    list: data.contact
  }), /* @__PURE__ */ React12.createElement(FollowDol, {
    list: data.socials
  })), /* @__PURE__ */ React12.createElement(CourseLayout, null, /* @__PURE__ */ React12.createElement(ColumnInfo, {
    title: "KH\xD3A H\u1ECCC IELTS",
    list: data.courses
  }), /* @__PURE__ */ React12.createElement("div", {
    className: "right-area"
  }, /* @__PURE__ */ React12.createElement(ColumnInfo, {
    title: "KH\xD3A H\u1ECCC KH\xC1C",
    list: data.anotherCourses
  }), /* @__PURE__ */ React12.createElement(ColumnInfo, {
    title: "V\u1EC0 DOL",
    list: data.aboutDol
  }))))), /* @__PURE__ */ React12.createElement(DmcaFooter, {
    list: data.dmca,
    shouldRenderDMCA
  })));
};
export {
  CommonFooter
};
//# sourceMappingURL=CommonFooter.esm.js.map
